<template>
    <div class="standalone-payment-methods">
        <input type="hidden" name="payment_method" :value="paymentMethod" />

        <!-- Errors -->
        <div class="alert alert-danger" v-if="Object.keys(errors).length > 0 && ! isLoadingRedirect">
            <ul class="my-0" v-for="errorKey in Object.keys(errors)">
                <li v-for="error in errors[errorKey]">
                    {{ error }}
                </li>
            </ul>
        </div>

        <!-- PayPal button -->
        <div id="paypal-standalone-button" v-if="! isHideOthers"></div>

        <!-- Payment methods -->
        <div v-if="! isHideOthers">
            <button class="btn btn-default btn-block payment-method-item" type="button" @click="selectMethod(method)" v-for="method in filteredPaymentMethods">
                <i class="wa-icon-long-arrow-right"></i>

                <!-- Logo -->
                <img :src="$cdn.default + 'assets/images/checkout/' + method + '-logo.svg?raw=true'" class="payment-logo" :class="method" />

                <!-- Name -->
                {{ 'checkout.steps.confirmation.paymentMethods.' + method | trans }}

                <!-- Info -->
                <small>
                    {{ 'checkout.steps.confirmation.paymentMethods.' + method + 'Info' | trans }}
                </small>
            </button>
        </div>

        <!-- Back button -->
        <button type="button" class="btn btn-link back-button" v-if="isHideOthers && ! isLoadingRedirect" @click="isHideOthers = false">
            <i class="wa-icon-long-arrow-left" style="vertical-align: middle;"></i>

            {{ 'checkout.pay.changePaymentMethod' | trans }}
        </button>

        <div v-if="isHideOthers && ! isLoadingRedirect">
            <div class="divider mt-2 mb-4"></div>

            <!-- Logo -->
            <img :src="$cdn.default + 'assets/images/checkout/' + paymentMethod + '-logo.svg?raw=true'" class="payment-logo" :class="paymentMethod" v-if="paymentMethod !== 'paypal'" />

            <h5>
                {{ 'checkout.steps.confirmation.paymentMethods.' + paymentMethod | trans }}
            </h5>

            <p class="payment-instructions">
                <span :inner-html.prop="'checkout.steps.confirmation.paymentMethods.' + paymentMethod + 'Instructions' | trans"></span>
            </p>

            <!-- Credit card -->
            <div class="credit-card-form" v-if="paymentMethod == 'credit_card'">
                <i class="fa fa-spinner fa-spin" v-if="isLoadingStripe || ! stripeCard"></i>

                <div id="card-element" :style="{ display: (isLoadingStripe ? 'none' : 'block') }"></div>

                <!-- Error -->
                <div class="alert alert-danger" v-if="stripeErrorMessage">
                    {{ stripeErrorMessage }}
                </div>
            </div>

            <!-- Direct debit -->
            <div class="direct-debit-form" v-if="paymentMethod == 'direct_debit'">
                <div class="row">
                    <div class="col-md-6">
                        <!-- Institut -->
                        <div class="form-group">
                            <label for="directDebitInstitut">
                                {{ 'checkout.steps.confirmation.institut' | trans }}
                                <span class="required">*</span>
                            </label>
                            <input type="text" name="direct_debit[institut]" class="form-control" id="directDebitInstitut" />
                        </div>
                    </div>

                    <div class="col-md-6">
                        <!-- Account holder -->
                        <div class="form-group">
                            <label for="directDebitAccountHolder">
                                {{ 'checkout.steps.confirmation.accountHolder' | trans }}
                                <span class="required">*</span>
                            </label>
                            <input type="text" name="direct_debit[account_holder]" class="form-control" id="directDebitAccountHolder" />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <!-- IBAN -->
                        <div class="form-group">
                            <label for="directDebitIban">
                                {{ 'checkout.steps.confirmation.iban' | trans }}
                                <span class="required">*</span>
                            </label>
                            <input type="text" name="direct_debit[iban]" class="form-control" id="directDebitIban" />
                        </div>
                    </div>

                    <div class="col-md-6">
                        <!-- BIC -->
                        <div class="form-group">
                            <label for="directDebitBic">
                                {{ 'checkout.steps.confirmation.bic' | trans }}
                                <span class="required">*</span>
                            </label>
                            <input type="text" name="direct_debit[bic]" class="form-control" id="directDebitBic" />
                        </div>
                    </div>
                </div>
            </div>

            <!-- PayPal -->
            <div class="paypal-form" v-if="paymentMethod === 'paypal'">
                <div id="paypal-button"></div>

                <!-- Error -->
                <div class="alert alert-danger" v-if="paypalErrorMessage">
                    {{ paypalErrorMessage }}
                </div>

                <div class="divider"></div>
            </div>

            <button type="button" class="btn btn-primary btn-lg btn-block mt-4 book-action" @click="pay" :disabled="isLoading || stripeErrorMessage" v-if="paymentMethod !== 'paypal'">
                <span v-if="! isLoading">
                    {{ 'checkout.pay.payNow' | trans }}
                    <i class="wa-icon-long-arrow-right"></i>
                </span>

                <svg class="white-loader" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" v-if="isLoading">
                    <circle class="internal-circle" cx="60" cy="60" r="30"></circle>
                    <circle class="external-circle" cx="60" cy="60" r="50"></circle>
                </svg>
            </button>
        </div>

        <!-- Abort booking -->
        <a :href="$window.route('frontend.checkout.cancel', { booking: bookingToken })" class="btn btn-link text-danger mt-4 btn-block" v-if="! isLoadingRedirect && isSingle === false">
            {{ 'checkout.thankYou.cancelledPaymentCard.abortButton' | trans }}
        </a>

        <!-- Redirect loader -->
        <div class="my-4 text-center" v-if="isLoadingRedirect">
            <svg class="loader" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" >
                <circle class="internal-circle" cx="60" cy="60" r="30"></circle>
                <circle class="external-circle" cx="60" cy="60" r="50"></circle>
            </svg>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['bookingId', 'direct', 'paymentMethods', 'stripeKey', 'stripePaymentIntent', 'paypalClientId', 'customerName', 'selected', 'amount', 'statementDescription', 'returnUrl', 'isSingle', 'bookingToken'],
        data() {
            return {
                paymentMethod: null,
                errors: {},
                isLoading: false,
                isLoadingRedirect: false,
                isHideOthers: false,
                clientSideMethods: ['direct_debit', 'giropay', 'credit_card', 'sofort', 'ideal', 'eps', 'paypal', 'bancontact', 'klarna'],
                clietSideDirectMethods: ['sofort', 'giropay', 'ideal', 'eps', 'bancontact', 'klarna'],
                hiddenPaymentMethods: ['paypal'],

                // Stripe SDK
                isLoadingStripe: true,
                stripeErrorMessage: null,
                stripe: null,
                stripeElements: null,
                stripeCard: null,

                // PayPal SDK
                paypalErrorMessage: null,
            }
        },
        mounted() {
            // Include Stripe SDK
            let stripeScript = document.createElement('script')
            stripeScript.onload = this.initStripe
            stripeScript.setAttribute('src', 'https://js.stripe.com/v3/')
            document.head.appendChild(stripeScript)

            // Set initial payment metho
            this.paymentMethod = this.selected ? this.selected : this.paymentMethods[0]
            this.isHideOthers = this.selected ? true : false

            // Include PayPal SDK
            let paypalScript = document.createElement('script')
            paypalScript.onload = this.initPaypal
            paypalScript.setAttribute('src', 'https://www.paypal.com/sdk/js?client-id=' + this.paypalClientId + '&currency=EUR&intent=authorize')
            document.head.appendChild(paypalScript)
        },
        computed: {
            // Filter hidden payment methods
            filteredPaymentMethods() {
                return this.paymentMethods.filter(method => this.hiddenPaymentMethods.indexOf(method) === -1)
            }
        },
        methods: {
            // Init stripe
            initStripe() {
                console.log('New stripe instance was created successfully!')

                this.stripe = Stripe(this.stripeKey);
                this.stripeElements = this.stripe.elements();

                if (this.paymentMethod === 'credit_card') {
                    this.setupStripeCard()
                } else if (this.direct === 'true') {
                    this.selectMethod(this.paymentMethod)
                }
            },

            initPaypal() {
                // Setup paypal button if required
                if (this.isHideOthers === false) {
                    this.setupPaypal('#paypal-standalone-button')
                } else if (this.isHideOthers === true && this.paymentMethod === 'paypal') {
                    this.setupPaypal('#paypal-button')
                }
            },

            // Setup the card element including event listener
            setupStripeCard() {
                var self = this
                this.isLoadingStripe = true

                // Prevent if stripe elements aren't ready
                if (! this.stripeElements) return;

                // Prevent multiple creations
                if (this.stripeCard) {
                    setTimeout(() => {
                        self.stripeCard.mount("#card-element");
                    }, 200);

                    return;
                }

                // Setup stripe
                this.stripeCard = this.stripeElements.create('card', {
                    style: {
                        base: {
                            color: "#212424",
                            fontWeight: 400,
                            fontFamily: 'Filson Soft, sans-serif',
                            fontSize: '15px',
                            fontSmoothing: 'antialiased',
                        }
                    },
                });

                this.stripeCard.on('change', ({error}) => {
                    if (error) {
                        self.stripeErrorMessage = error.message
                    } else {
                        self.stripeErrorMessage = null
                    }
                });
                this.stripeCard.on('ready', ({error}) => {
                    self.isLoadingStripe = false
                    self.stripeCard.focus()
                });

                setTimeout(() => {
                    self.stripeCard.mount("#card-element");
                }, 200);
            },

            setupPaypal(target = null) {
                // Reset errors
                this.errors = {}
                this.paypalErrorMessage = null
                this.isLoading = false

                if (typeof(paypal) === 'undefined') {
                    this.paypalErrorMessage = 'Sorry, it is not possible to pay with PayPal. Please try again later.'
                    return;
                }

                var self = this
                
                // Create a PayPal Checkout component.
                setTimeout(() => {
                    self.initPayPalButton(target);
                }, 200);
            },

            initPayPalButton(target = '#paypal-standalone-button') {
                console.log(target)
                var self = this
                paypal.Buttons({    
                    fundingSource: paypal.FUNDING.PAYPAL,

                    createOrder: function (data, actions) {
                        return actions.order.create({
                            purchase_units: [{
                                amount: {
                                    currency_code: 'EUR',
                                    value: String(Number(self.amount).toFixed(2)),
                                },
                                custom_id: String(self.bookingId),
                            }]
                        });
                    },
                    
                    onApprove: function (data, actions) {
                        self.paymentMethod = 'paypal'

                        // Authorize the transaction
                        actions.order.authorize().then(function(authorization) {
                            // Get the authorization id
                            var authorizationID = authorization.purchase_units[0].payments.authorizations[0].id
                            
                            var form = $('form')[0]

                            // Append order id
                            $('<input />').attr('type', 'hidden')
                            .attr('name', 'paypal_order_id')
                            .attr('value', data.orderID)
                            .appendTo(form)

                            // Append authorization id
                            $('<input />').attr('type', 'hidden')
                            .attr('name', 'paypal_authorization_id')
                            .attr('value', authorizationID)
                            .appendTo(form)

                            form.submit()
                        });
                    },
                    
                    onCancel: function (data) {
                        console.log('PayPal payment cancelled', JSON.stringify(data, 0, 2));
                        self.isHideOthers = false
                    },
                    
                    onError: function (err) {
                        self.paypalErrorMessage = 'PayPal error', err
                        console.error('PayPal error', err);
                    }
                }).render(target);
            },

            pay() {
                var self = this
                this.errors = {}
                this.isLoading = true

                var form = $('form')[0]

                // Client side payment process
                if (this.clientSideMethods.indexOf(this.paymentMethod) !== -1) {
                    switch (this.paymentMethod) {
                        // Credit card
                        case 'credit_card':
                            this.handleCardPayment()
                            break;

                        // Sofot
                        case 'sofort':
                            this.handleSofortPayment()
                            break;

                        // iDEAL
                        case 'ideal':
                            this.handleIdealPayment()
                            break;

                        // eps
                        case 'eps':
                            this.handleEpsPayment()
                            break;

                        // Bancontact
                        case 'bancontact':
                            this.handleBancontactPayment()
                            break;

                        // Klarna
                        case 'klarna':
                            this.isLoadingRedirect = true

                            setTimeout(() => form.submit(), 200)
                            break;

                        // Direct debit
                        case 'direct_debit':
                            this.isLoading = true

                            setTimeout(() => form.submit(), 200)
                            break;

                        // Giropay
                        case 'giropay':
                            this.isLoadingRedirect = true

                            setTimeout(() => form.submit(), 200)
                            break;
                    }
                } else {
                    this.isLoadingRedirect = true
                    setTimeout(() => form.submit(), 200)
                }
            },

            // Credit card payment
            handleCardPayment() {
                var self = this
                var form = $('form')[0]

                this.stripe.confirmCardPayment(this.stripePaymentIntent, {
                    payment_method: {
                        card: this.stripeCard,
                        billing_details: {
                            name: this.customerName,
                        }
                    }
                }).then(function(result) {
                    if (result.error) {
                        self.errors = {
                            stripe: [result.error.message],
                        }

                        if ($(window).scrollTop() > 120) {
                            setTimeout(function() {
                                $('html,body').stop().animate({
                                    scrollTop: $('div.standalone-payment-methods').offset().top - 30
                                }, 500, 'swing');
                            }, 100);
                        }

                        self.isLoading = false
                    } else {
                        if (result.paymentIntent.status === 'succeeded') {
                            // Append stripe payment to form data
                            $('<input />').attr('type', 'hidden')
                            .attr('name', 'stripe_payment_id')
                            .attr('value', result.paymentIntent.id)
                            .appendTo(form)

                            form.submit()
                        }
                    }
                });
            },

            // Sofort Überweisung
            handleSofortPayment() {
                var self = this
                var form = $('form')[0]

                this.isLoadingRedirect = true

                this.stripe.createSource({
                    type: 'sofort',
                    amount: Math.ceil(this.amount * 100),
                    currency: 'eur',
                    statement_descriptor: this.statementDescription,
                    redirect: {
                        return_url: this.returnUrl,
                    },
                    sofort: {
                        country: 'DE',
                    },
                }).then(function(result) {
                    if (result.error) {
                        self.errors = {
                            sofort: {
                                invalid: window.Lang.get('checkout.steps.confirmation.paymentMethods.notAvailable'),
                            },
                        }
                        self.hiddenPaymentMethods.push('sofort');
                        self.paymentMethod = null
                        self.isHideOthers = false
                        self.isLoadingRedirect = false
                        self.isLoading = false
                    } else {
                        // Append stripe source id to form data
                        $('<input />').attr('type', 'hidden')
                        .attr('name', 'stripe_source_id')
                        .attr('value', result.source.id)
                        .appendTo(form)

                        // Append redirect url to form data
                        $('<input />').attr('type', 'hidden')
                        .attr('name', 'redirect_url')
                        .attr('value', result.source.redirect.url)
                        .appendTo(form)

                        form.submit()
                    }
                });
            },

            // iDEAL
            handleIdealPayment() {
                var self = this
                var form = $('form')[0]

                this.isLoadingRedirect = true

                this.stripe.createSource({
                    type: 'ideal',
                    amount: Math.ceil(this.amount * 100),
                    currency: 'eur',
                    statement_descriptor: this.statementDescription,
                    redirect: {
                        return_url: this.returnUrl,
                    },
                }).then(function(result) {
                    if (result.error) {
                        self.errors = {
                            ideal: {
                                invalid: window.Lang.get('checkout.steps.confirmation.paymentMethods.notAvailable'),
                            },
                        }
                        self.hiddenPaymentMethods.push('ideal');
                        self.paymentMethod = null
                        self.isHideOthers = false
                        self.isLoadingRedirect = false
                        self.isLoading = false
                    } else {
                        // Append stripe source id to form data
                        $('<input />').attr('type', 'hidden')
                        .attr('name', 'stripe_source_id')
                        .attr('value', result.source.id)
                        .appendTo(form)

                        // Append redirect url to form data
                        $('<input />').attr('type', 'hidden')
                        .attr('name', 'redirect_url')
                        .attr('value', result.source.redirect.url)
                        .appendTo(form)

                        form.submit()
                    }
                });
            },

            // eps
            handleEpsPayment() {
                var self = this
                var form = $('form')[0]

                this.isLoadingRedirect = true

                this.stripe.createSource({
                    type: 'eps',
                    amount: Math.ceil(this.amount * 100),
                    currency: 'eur',
                    statement_descriptor: this.statementDescription,
                    redirect: {
                        return_url: this.returnUrl,
                    },
                    owner: {
                        name: this.customerName,
                    }
                }).then(function(result) {
                    if (result.error) {
                        self.errors = {
                            eps: {
                                invalid: window.Lang.get('checkout.steps.confirmation.paymentMethods.notAvailable'),
                            },
                        }
                        self.hiddenPaymentMethods.push('eps');
                        self.paymentMethod = null
                        self.isHideOthers = false
                        self.isLoadingRedirect = false
                        self.isLoading = false
                    } else {
                        // Append stripe source id to form data
                        $('<input />').attr('type', 'hidden')
                        .attr('name', 'stripe_source_id')
                        .attr('value', result.source.id)
                        .appendTo(form)

                        // Append redirect url to form data
                        $('<input />').attr('type', 'hidden')
                        .attr('name', 'redirect_url')
                        .attr('value', result.source.redirect.url)
                        .appendTo(form)

                        form.submit()
                    }
                });
            },

            // Bancontact
            handleBancontactPayment() {
                var self = this
                var form = $('form')[0]

                this.isLoadingRedirect = true

                this.stripe.createSource({
                    type: 'bancontact',
                    amount: Math.ceil(this.amount * 100),
                    currency: 'eur',
                    statement_descriptor: this.statementDescription,
                    redirect: {
                        return_url: this.returnUrl,
                    },
                    owner: {
                        name: this.customerName,
                    }
                }).then(function(result) {
                    if (result.error) {
                        self.errors = {
                            bancontact: {
                                invalid: window.Lang.get('checkout.steps.confirmation.paymentMethods.notAvailable'),
                            },
                        }
                        self.hiddenPaymentMethods.push('bancontact');
                        self.paymentMethod = null
                        self.isHideOthers = false
                        self.isLoadingRedirect = false
                        self.isLoading = false
                    } else {
                        // Append stripe source id to form data
                        $('<input />').attr('type', 'hidden')
                        .attr('name', 'stripe_source_id')
                        .attr('value', result.source.id)
                        .appendTo(form)

                        // Append redirect url to form data
                        $('<input />').attr('type', 'hidden')
                        .attr('name', 'redirect_url')
                        .attr('value', result.source.redirect.url)
                        .appendTo(form)

                        form.submit()
                    }
                });
            },

            selectMethod(method) {
                this.paymentMethod = method

                if (this.clientSideMethods.indexOf(method) === -1 || this.clietSideDirectMethods.indexOf(method) !== -1) {
                    this.pay()
                }

                // Hide others
                this.isHideOthers = true

                // Reset errors
                this.errors = {}
                this.stripeErrorMessage = null
                this.paypalErrorMessage = null
                this.isLoading = false

                // Setup stripe credit card element
                if (this.paymentMethod === 'credit_card') {
                    this.setupStripeCard()
                } else {
                    if (this.stripeCard) {
                        this.stripeCard.unmount()
                    }
                }

                // Start PayPal
                if (this.paymentMethod === 'paypal') {
                    this.setupPaypal('#paypal-button')
                }
            },
        },
        watch: {
            isHideOthers() {
                if (this.isHideOthers === false) {
                    this.setupPaypal('#paypal-standalone-button')
                }
            },
        },
    }
</script>
